import SpinnerGap from '@svg/spinner-gap.svg';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

export const AnimatedSpinnerGapIcon = styled(SpinnerGap)`
  animation: ${spin} 3s linear infinite;
`;
